import Container from 'react-bootstrap/Container';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import logo from '../../images/logo.png';
import { connect } from 'react-redux';
import { Outlet, NavLink, Link } from "react-router-dom";
import React, { useState } from 'react';
import { LOGO_IMG_PATH } from '../general/utils';

function Navigation(props) {
  const { isLoggedIn, username, organization_id, roles, modules, organization, features } = props;
  const [isOpen, setIsOpen] = useState(false);

  const env = process.env.REACT_APP_ENV;

  const closeNavBar = (e, value) => {
    if (e.target.classList[0] === 'dropdown-toggle') {
      return setIsOpen(!value);
    }
    setIsOpen(value);
  };

  const getNameInitials = (username) => {
    if (!username) return 'NU';
    const parts = username.split(' ');
    return [(parts[0] || ''), (parts[1] || '')].map(a => a[0]).join('');
  };

  return (
    <>
      <Navbar className="abi-navbar" expand="lg" fixed="top" expanded={isOpen} onClick={(e) => closeNavBar(e, !isOpen)}>
        <Container fluid>
          <Navbar.Brand as={Link} to={isLoggedIn ? '/main' : '/home'} onClick={(e) => { e.stopPropagation(); setIsOpen(false); }}>
            <img src={logo} height="28" className="d-inline-block align-middle rounded" alt="Abi" />
            {isLoggedIn && organization ? (
              <>
                <img height="28" src={LOGO_IMG_PATH + organization.id + '.png'} className="rounded" alt="" />
                <span>{organization.name || 'Usuario sin entidad asignada'}</span>
              </>
            ) : (
              <span>¡Bienvenido!</span>
            )}
            {env === 'qa'  && <span className="env-badge">QA</span>}
            {env === 'dev' && <span className="env-badge">DEV</span>}
          </Navbar.Brand>

          {isLoggedIn && (
            <>
              <Navbar.Toggle aria-controls="abi-navbar-nav" />
              <Navbar.Collapse id="abi-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link
                    as={NavLink}
                    to="/main"
                    onClick={(e) => closeNavBar(e, false)}
                  >
                    <i className="fa fa-home" />{' '}Inicio
                  </Nav.Link>

                  {organization_id && (
                    <>
                      {!roles.includes('superadmin') && (
                        <>
                          <Nav.Link
                            as={NavLink}
                            to="/products"
                            onClick={(e) => closeNavBar(e, false)}
                          >
                            <i className="fa fa-shopping-cart" />{' '}Productos
                          </Nav.Link>

                          <NavDropdown title="Pedidos" id="pedidos-dropdown">
                            {roles.includes('customer_order') && (
                              <NavDropdown.Item as={NavLink} to="/order/create" onClick={(e) => closeNavBar(e, false)}>
                                Crear
                              </NavDropdown.Item>
                            )}
                            {(roles.includes('customer_order') || roles.includes('provider_order')) && (
                              <NavDropdown.Item as={NavLink} to="/order/edit" onClick={(e) => closeNavBar(e, false)}>
                                Modificar
                              </NavDropdown.Item>
                            )}
                            {(roles.includes('customer_approver') || roles.includes('provider_approver')) && (
                              <NavDropdown.Item as={NavLink} to="/order/approve" onClick={(e) => closeNavBar(e, false)}>
                                Aprobar
                              </NavDropdown.Item>
                            )}
                            <NavDropdown.Item as={NavLink} to="/order/search" onClick={(e) => closeNavBar(e, false)}>
                              Consultar
                            </NavDropdown.Item>
                          </NavDropdown>

                          <NavDropdown title="Reportes" id="reportes-dropdown">
                            {(() => {
                              // Flag por organizacion: algunas entidades (ej. requisitos de
                              // pliego de licitacion) necesitan que el rol customer_order
                              // tambien vea los reportes de presupuesto/consumo, sin abrirlo
                              // para el resto de tenants que no lo pidieron.
                              const orderReportsCfg = features && features.order_role_reports;
                              const canOrderSeeReports =
                                !!(orderReportsCfg && orderReportsCfg.enabled) && roles.includes('customer_order');

                              const isAdminOrReader =
                                roles.includes('customer_admin') || roles.includes('provider_admin') ||
                                roles.includes('customer_reader') || roles.includes('provider_reader');
                              const canSeeExecutive =
                                roles.includes('customer_admin') || roles.includes('provider_admin');
                              const isCustomerBudget =
                                roles.includes('customer_admin') || roles.includes('customer_approver') ||
                                roles.includes('customer_reader') || roles.includes('provider_reader') ||
                                canOrderSeeReports;
                              const isBothSidesAdmin =
                                roles.includes('customer_admin') || roles.includes('provider_admin') ||
                                roles.includes('customer_reader') || roles.includes('provider_reader') ||
                                canOrderSeeReports;
                              const canSeeOrderReport =
                                roles.includes('customer_admin') || roles.includes('provider_admin') ||
                                roles.includes('customer_approver') || roles.includes('provider_approver') ||
                                roles.includes('customer_reader') || roles.includes('provider_reader') ||
                                roles.includes('customer_order') || roles.includes('provider_order');

                              return (
                                <>
                                  {/* ── Gerencial ── */}
                                  {canSeeExecutive && (
                                    <>
                                      <NavDropdown.ItemText className="dropdown-subheader">
                                        <i className="fa fa-tachometer" /> Gerencial
                                      </NavDropdown.ItemText>
                                      <NavDropdown.Item as={NavLink} to="/report/executive" onClick={(e) => closeNavBar(e, false)}>
                                        Dashboard Ejecutivo
                                      </NavDropdown.Item>
                                      <NavDropdown.Divider />
                                    </>
                                  )}

                                  {/* ── Presupuesto (lado cliente) ── */}
                                  {isCustomerBudget && (
                                    <>
                                      <NavDropdown.ItemText className="dropdown-subheader">
                                        <i className="fa fa-money" /> Presupuesto
                                      </NavDropdown.ItemText>
                                      {(roles.includes('customer_admin') || roles.includes('customer_approver') || roles.includes('customer_reader') || roles.includes('provider_reader') || canOrderSeeReports) && (
                                        <NavDropdown.Item as={NavLink} to="/report/funds" onClick={(e) => closeNavBar(e, false)}>
                                          Fondos
                                        </NavDropdown.Item>
                                      )}
                                      <NavDropdown.Item as={NavLink} to="/report/departments" onClick={(e) => closeNavBar(e, false)}>
                                        Consumo por Departamento
                                      </NavDropdown.Item>
                                      <NavDropdown.Divider />
                                    </>
                                  )}

                                  {/* ── Consumo (ambos lados, nivel admin) ── */}
                                  {isBothSidesAdmin && (
                                    <>
                                      <NavDropdown.ItemText className="dropdown-subheader">
                                        <i className="fa fa-bar-chart" /> Consumo
                                      </NavDropdown.ItemText>
                                      <NavDropdown.Item as={NavLink} to="/report/monthly" onClick={(e) => closeNavBar(e, false)}>
                                        Consolidado Mes
                                      </NavDropdown.Item>
                                      <NavDropdown.Item as={NavLink} to="/report/products" onClick={(e) => closeNavBar(e, false)}>
                                        Análisis de Productos
                                      </NavDropdown.Item>
                                      <NavDropdown.Divider />
                                    </>
                                  )}

                                  {/* ── Logística ── */}
                                  <NavDropdown.ItemText className="dropdown-subheader">
                                    <i className="fa fa-truck" /> Logística
                                  </NavDropdown.ItemText>
                                  <NavDropdown.Item as={NavLink} to="/report/deliveries" onClick={(e) => closeNavBar(e, false)}>
                                    Entregas programadas
                                  </NavDropdown.Item>

                                  {/* ── Pedidos (admins, aprobadores y readers) ── */}
                                  {canSeeOrderReport && (
                                    <NavDropdown.Item as={NavLink} to="/report/orders" onClick={(e) => closeNavBar(e, false)}>
                                      Reporte de Pedidos
                                    </NavDropdown.Item>
                                  )}
                                </>
                              );
                            })()}
                          </NavDropdown>
                        </>
                      )}

                      {roles.includes('superadmin') && (
                        <Nav.Link as={NavLink} to="/admin/logs" onClick={(e) => closeNavBar(e, false)}>
                          <i className="fa fa-terminal" />{' '}Logs
                        </Nav.Link>
                      )}

                      {(roles.includes('customer_admin') || roles.includes('provider_admin') || roles.includes('superadmin')) && (
                        <NavDropdown title="Configuración" id="config-dropdown">
                          {(roles.includes('customer_admin') || roles.includes('provider_admin')) && (
                            <NavDropdown.Item as={NavLink} to="/config/organization" onClick={(e) => closeNavBar(e, false)}>
                              Entidad
                            </NavDropdown.Item>
                          )}
                          {roles.includes('customer_admin') && (
                            <NavDropdown.Item as={NavLink} to="/config/departments" onClick={(e) => closeNavBar(e, false)}>
                              Centros de costos
                            </NavDropdown.Item>
                          )}
                          {roles.includes('provider_admin') && (
                            <>
                              <NavDropdown.Item as={NavLink} to="/config/product-types" onClick={(e) => closeNavBar(e, false)}>
                                Tipos de Producto
                              </NavDropdown.Item>
                              <NavDropdown.Item as={NavLink} to="/config/products" onClick={(e) => closeNavBar(e, false)}>
                                Productos
                              </NavDropdown.Item>
                            </>
                          )}
                          {(roles.includes('customer_admin') || roles.includes('provider_admin')) && (
                            <NavDropdown.Item as={NavLink} to="/config/funds" onClick={(e) => closeNavBar(e, false)}>
                              Fondos
                            </NavDropdown.Item>
                          )}
                          {(roles.includes('superadmin') || roles.includes('customer_admin') || roles.includes('provider_admin')) && (
                            <NavDropdown.Item as={NavLink} to="/config/users" onClick={(e) => closeNavBar(e, false)}>
                              Usuarios
                            </NavDropdown.Item>
                          )}
                        </NavDropdown>
                      )}
                    </>
                  )}
                </Nav>

                <Nav>
                  <Nav.Link as={NavLink} to="/help" onClick={(e) => closeNavBar(e, false)}>
                    <i className="fa fa-question" />{' '}Ayuda
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/user" onClick={(e) => closeNavBar(e, false)}>
                    <span className="profile-icon">{getNameInitials(username)}</span>
                    {username}
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/logout" onClick={(e) => closeNavBar(e, false)}>
                    <i className="fa fa-sign-out" />{' '}Salir
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </>
          )}

          {!isLoggedIn && (
            <Nav className="ms-auto flex-row" style={{ gap: 8 }}>
              <Nav.Link as={NavLink} to="/help"><i className="fa fa-question" />{' '}Ayuda</Nav.Link>
              <Nav.Link as={NavLink} to="/login"><i className="fa fa-sign-in" />{' '}Ingresar</Nav.Link>
            </Nav>
          )}
        </Container>
      </Navbar>

      <div className="app-content">
        <Container fluid>
          <Outlet />
        </Container>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  username: state.username,
  organization_id: state.organization_id,
  roles: state.roles,
  modules: state.modules,
  organization: state.organization,
  isLoggedIn: state.isLoggedIn,
  features: state.features,
});

export default connect(mapStateToProps)(Navigation);
